import { SidePanelContext } from "components/SidePanel/SidePanelContext";
import React, { useContext } from "react";
import { InPageEditableSectionField, TwoColumnInPageEditableSectionField } from "../types";
import { InPageEditableFieldSidePanelNarrow, InPageEditableFieldSidePanelWide } from "./InPageEditableFieldSidePanel";
import { flattenTwoColumnFields } from "./convertSectionsToSidePanel";

interface SidePanelSectionTemplateProps {
  fields: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField>;
  isInPageEditable: boolean;
  compact?: boolean;
  displayEmptyValues?: boolean;
}

export const SidePanelSectionTemplate = (props: SidePanelSectionTemplateProps) => {
  const { layoutType } = useContext(SidePanelContext);

  const isFieldHidden = (field: InPageEditableSectionField | TwoColumnInPageEditableSectionField): boolean => {
    if (field.hidden) return true;
    if (!props.isInPageEditable && field.isEmpty && !props.displayEmptyValues) return true;

    return false;
  }

  const visibleFields = props.fields.filter(field => !isFieldHidden(field));

  if (layoutType === "narrow") {
    return <div className="side-panel-section-template-narrow-list">
      {flattenTwoColumnFields(visibleFields).map(field => <InPageEditableFieldSidePanelNarrow
        key={field.key}
        compact={props.compact}
        field={field}
      />)}
    </div>
  }

  return <div className="side-panel-section-template-grid">
    {visibleFields.map(field => <InPageEditableFieldSidePanelWide
      key={field.key}
      compact={props.compact}
      field={field}
    />)}
  </div>
}